import { ComissionResponseDto } from "../dto/response/comission-response-dto";
import { Comission } from "../model/comission.model";

export function toComission(dto: ComissionResponseDto): Comission[] {
  return dto.data.map(
    (comission) =>
      ({
        id: comission.id,
        orderId: comission.orderId,
        productName: comission.productStreamer.name,
        productPrice: Number(comission.productSalePrice),
        productQuantity: comission.productSaleQuantity,
        orderStatus: comission.order.currentStatus,
        comissionPercentage: comission.percentage,
        comissionValue: comission.commissionValue,
        createdAt: comission.createdAt,
        buyerName:
          comission.walletTransaction?.description || "Usuário anônimo"}) as Comission,
  );
}
